import { Controller } from "@hotwired/stimulus"
import Preferences from "../models/preferences"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    const theme = Preferences.theme
    this.applyTheme(theme)
    if (this.hasToggleTarget) {
      this.toggleTarget.checked = theme === "dark"
    }
  }

  toggle(event) {
    const theme = event.target.checked ? "dark" : "light"
    this.applyTheme(theme)
    Preferences.theme = theme
  }

  applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme)
  }
}
